export default __webpack_public_path__ + "assets/attention-component.0a0e7590.svg";